import { useEffect, useState } from 'react';

const useIsKeyboardOpen = () => {
  const [ keyboardDiff, setKeyboardDiff ] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const viewHeight = window?.visualViewport?.height;
      const heightDiff = viewHeight ? window?.innerHeight - viewHeight : 0;

      // Only update keyboardDiff if the difference is greater than the threshold (100)
      if (heightDiff > 100) {
        setKeyboardDiff(heightDiff);
      } else {
        setKeyboardDiff(0); // Set to 0 if the difference is too small (e.g., URL bar change)
      }
    };

    // Add visualViewport listener for modern browsers
    window.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isKeyboardOpen: keyboardDiff > 0,
    keyboardDiff,
  };
};

export default useIsKeyboardOpen;
